import _extends from "@babel/runtime-corejs2/helpers/esm/extends";
import _slicedToArray from "@babel/runtime-corejs2/helpers/esm/slicedToArray";
import * as React from 'react';
import { ChevronRightIcon } from '@origin-digital/icon';
import { Heading } from './Heading';
import { ANIMATION } from '../../consts/metrics.const';
import { splitLastWord } from '../../helpers/string.helpers';
import styled, { css } from 'styled-components';
var ChevronHeadingContainer = styled(Heading).withConfig({
  displayName: "HeadingChevron__ChevronHeadingContainer",
  componentId: "sc-1wb53us-0"
})(["svg{transform:translate(", ");transition:transform ", ";}span{font:inherit;}span:last-child{white-space:nowrap;}"], ANIMATION.CHEVRON.TRANSLATE_MIN, ANIMATION.CHEVRON.SPEED);

var HeadingChevronIcon = function HeadingChevronIcon(_ref) {
  var chevronColor = _ref.chevronColor;
  return React.createElement(ChevronRightIcon, {
    accessibilityLabel: "chevron right",
    size: "24",
    color: chevronColor
  });
};

var HeadingChevron = function HeadingChevron(props) {
  var _splitLastWord = splitLastWord(props.text),
      _splitLastWord2 = _slicedToArray(_splitLastWord, 2),
      first = _splitLastWord2[0],
      last = _splitLastWord2[1];

  return React.createElement(ChevronHeadingContainer, _extends({
    size: 4
  }, props), React.createElement("span", null, first), React.createElement("span", null, last), React.createElement(HeadingChevronIcon, {
    chevronColor: props.chevronColor
  }));
};

HeadingChevron.defaultProps = {
  chevronColor: 'redPink'
};
var headingLinkOnHoverMixin = css(["&:hover ", " svg{transform:translate(", ");}"], ChevronHeadingContainer, ANIMATION.CHEVRON.TRANSLATE_MAX);
var HeadingLinkHoverContainer = styled.div.withConfig({
  displayName: "HeadingChevron__HeadingLinkHoverContainer",
  componentId: "sc-1wb53us-1"
})(["", ";"], headingLinkOnHoverMixin);
export { HeadingChevron, HeadingLinkHoverContainer, headingLinkOnHoverMixin };